<!--20211103 sea bert 栏目标题-->
<template>
  <div class="title_and_subtitle">
    <div class="title_and_subtitle_title">
      <p>{{ title }}</p>
<!--      <img src="~@/assets/images/mainindex/icon-notice-bg@2x.png" alt="" />-->
    </div>
    <div class="title_and_subtitle_subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ColumnTitle",
  props:{
      title:"",//标题
      subtitle:"",//子标题
      src:""    //背景图 link
  }
};
</script>
<style lang="scss" scoped>
.title_and_subtitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0 40px 0;
  .title_and_subtitle_title {
    // width: 286px;
    height: 51px;
    position: relative;
    p {
      font-size: 32px;
      font-weight: 600;
      color: #333333;
      // padding-left: 57px;
    }
    img {
      position: absolute;
      bottom: 0;
      width: 286px;
      height: 33px;
    }
  }
  .title_and_subtitle_subtitle {
    max-width: 1200px;
    margin-top: 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// ColumnTitle.vue?553fd65e